import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
  size?: 'normal' | 'large';
}

export default function ComicCard({ comic, size = 'normal' }: ComicCardProps) {
  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group block"
      data-product-shop=""
    >
      <div className={`relative overflow-hidden rounded-lg bg-background-100 ${
        size === 'large' ? 'aspect-[3/4]' : 'aspect-[3/4]'
      }`}>
        <img
          src={comic.cover}
          alt={comic.title}
          title={`${comic.title} - 歪歪漫画网韩国漫画`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-3">
          <p className="text-background-50 text-xs line-clamp-2 leading-relaxed">{comic.description}</p>
        </div>
        {/* Status Badge */}
        <span
          className={`absolute top-2 left-2 px-2 py-0.5 rounded text-[10px] font-medium ${
            comic.status === '连载中'
              ? 'bg-primary-500 text-background-50'
              : 'bg-secondary-500 text-background-50'
          }`}
        >
          {comic.status}
        </span>
        {/* Rating */}
        <div className="absolute top-2 right-2 px-2 py-0.5 rounded text-[10px] font-semibold bg-foreground-950/60 text-accent-400 flex items-center gap-1">
          <i className="ri-star-fill text-[10px]"></i>
          {comic.rating}
        </div>
      </div>

      <div className="mt-2.5">
        <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1 font-heading">
          {comic.title}
        </h3>
        <div className="flex items-center gap-2 mt-1">
          <span className="text-xs text-foreground-500">{comic.author}</span>
          <span className="text-foreground-300 text-[10px]">·</span>
          <span className="text-xs text-foreground-400">{comic.category}</span>
        </div>
        {size === 'large' && (
          <div className="flex items-center gap-2 mt-1.5">
            <span className="text-xs text-foreground-400 flex items-center gap-1">
              <i className="ri-eye-line text-[10px]"></i>
              {comic.views >= 10000 ? `${(comic.views / 10000).toFixed(1)}万` : comic.views}
            </span>
            <span className="text-xs text-foreground-400 flex items-center gap-1">
              <i className="ri-heart-line text-[10px]"></i>
              {comic.favorites >= 10000 ? `${(comic.favorites / 10000).toFixed(1)}万` : comic.favorites}
            </span>
          </div>
        )}
      </div>
    </Link>
  );
}